import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Close } from '@shared/assets';
import { type PromoVideo } from '@shared/types/promo-videos';
import { IconButton } from '@shared/ui';
import st from './styles.module.scss';

interface Props {
  promo: PromoVideo | null;
  onRemove: () => void;
  // onClickPromo: () => void;
}

export const PromoInfoBtn: React.FC<Props> = ({ promo, onRemove }) => {
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (promo) {
      if (promo.video_type === 'B') {
        if (promo.metadata) {
          setTitle(promo.metadata.FileName);
        } else {
          setTitle(promo.title);
        }
      } else {
        setTitle(promo?.embed_url || '');
      }
    }
  }, [promo, title]);

  return (
    <div className={st.promoInfoWrapper}>
      {promo && (
        <Link to={`promo/${promo.id}`} className={st.promoInfo}>
          <div className={st.card__image}>
            <img src={promo?.screenshot_url} alt={promo?.title} />
          </div>

          <h3>{title}</h3>
        </Link>
      )}

      <IconButton variant="dark" size={'medium'} type="button" onClick={onRemove}>
        <Close />
      </IconButton>
    </div>
  );
};
